import http from '@/utils/http';

export default {
	getAll: data => {
		return http({ url: '/api/admin/v1/menu/getAll', data }).then(r => r);
	},
	myTree: data => {
		return http({ url: '/api/admin/v1/menu/myTree', data }).then(r => r);
	},
	save: data => {
		return http({ url: '/api/admin/v1/menu/save', data, tip: true }).then(r => r);
	},
	delete: data => {
		return http({ url: '/api/admin/v1/menu/delete', data, tip: true }).then(r => r);
	},
};
